// Theme palette paths used to colour user/group avatars by a hash of their id.
// Co-located with the theme so the avatar colour set lives in one place and can be
// tuned without touching the hashing logic. Chosen for enough contrast with the
// white avatar initials.
export const AVATAR_COLOURS = [
  'purple.500',
  'indigo.500',
  'green.700',
  'teal.500',
  'blue.700',
  'cyan.700',
  'deepOrange.500',
  'pink.500',
  'brown.500',
  'deepPurple.500',
] as const
